export { default } from "./ZendeskForm";
